import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { BaseComponent, ActionDialog } from "../../../base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { CadastroProdutoComponent } from "../cadastro-produto/cadastro-produto.component";
import { BoletaPrevidenciaService } from "app/previdencia/services/boleta-previdencia.service";
import { CadastroBoletaPrevidenciaComponent } from "app/previdencia/cadastro-boleta-previdencia/cadastro-boleta-previdencia.component";

@Component({
    selector: "app-cliente-previdencia",
    templateUrl: "./cliente-previdencia.component.html",
    styleUrls: ["./cliente-previdencia.component.scss"],
    providers:[BoletaPrevidenciaService]
})

export class ClientePrevidenciaComponent extends BaseComponent implements OnInit{

    user: any;        data_atualizacao: any;
    @Input() cliente_id!: number;

    constructor(public _service: BoletaPrevidenciaService, 
                public dialog: MatDialog,
                override snackBar: MatSnackBar,
                private _authService: AuthService) {
        super(dialog, snackBar);

        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser? strUser : "{}");
        this.params.per_page = this.pageSize;
    }

    ngOnInit(){

        this.pageSize = 5;
        this.pageSizeOptions = [5, 10, 20, 30];
    
        this.getAll();
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event:PageEvent){
        console.log(event);

        this.params.page = (event.pageIndex+1);
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    
    /**
     * Evento de ordenação da lista de produtos
     * @param event
    */
    onSort(event:any){
        this.params.sortColumn = event.column.prop;
        this.params.sortOrder = event.newValue;

        this.getAll();
    }
  

    /**
     * Consulta lista de empresas
     */
    getAll() {

        this.loadingIndicator   = true;
        this.params.cliente_id  = this.cliente_id;

        this._service.getAll(this.params).subscribe(
            data => {
                this.length = data.meta.total;
                this.rows = data.data;
                this.temp = [...this.rows];
            },
            error => {
                console.log("error: " + error);
                this.loadingIndicator = false;
            },
            () => {

                console.log("complete");
                this.loadingIndicator = false;
            }
        );
    }

    

    alterar(id:any): void {
        const dialogRef = this.dialog.open(CadastroProdutoComponent, {
            width: "400px",            
            data: {                
                id: id,
                titulo: "Alterar Boleta Previdência",
                service: this._service
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Histórico atualizado com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar atualizar o registro.");
            }
        });
    }

    
    delete(id: number) {

        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: {
                title: "Excluir COE",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.loadingIndicator = true;
                    lista._service.delete(id).subscribe(
                        data => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        error => {
                            lista.loadingIndicator = false;
                            console.log("error: " + error);
                            lista.showError(error.message);

                        },
                        () => {
                            console.log("complete");
                            lista.loadingIndicator = false;
                        }
                    );
                }
            }
        });
    }  

    orgaoEmissor(row:any){
        
        if (row.caracteristica.orgao_emissor != undefined && row.caracteristica.orgao_emissor != ""){
            return row.caracteristica.orgao_emissor.nome;
        }
        
        return "";
    }

    getVerificado(row:any){
        if(row.verificado_migracao){
             return "SIM";
        }else{
             return "NÃO";
        }    
    }

    getCnpj(row:any){
        if(row.caracteristica.cnpj != undefined){
            return row.caracteristica.cnpj;
        }
        
        return "";
    }

    openCadastro(){        
        const dialogRef = this.dialog.open(CadastroBoletaPrevidenciaComponent, {
            width: "600px",
            height: "600px",
            data: {
                acao_comercial_id: null,
                cliente_id: this.cliente_id,
                id: null
            }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            console.log(result);
            if (result != undefined && result != null && result != "cancel"){
                this.showSuccess("Boleta Previdência cadastrada com sucesso!");
                this.getAll();
            }else if(result != undefined && result != "cancel"){
                this.showError("Ocorreu um erro ao tentar cadastrar um nova boleta renda fixa.");
            }
        });        
    }
}
